import React from "react";
import { FaWhatsapp, FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import "../style.css";

const fleetData = [
    {
      id: 1,
     name: "Maruti Ertiga",
      tag: "Premium Fleet",
      description: "Looking for a reliable 7-seater car in Varanasi? Our Maruti Ertiga MPV offers the perfect blend of comfort and affordability.",
      prices: { airport: "Rs. 1300", "8hr": "Rs. 2300", "12hr": "Rs. 3000", outstation: "Rs. 15/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tavera-Ertiga.jpg"
    },
    {
      id: 2,
     name: "Swift Dzire",
      tag: "Premium Fleet",
      description: "Experience Varanasi with our affordable 4-seater sedan taxi service – ideal for city tours, family travel, business trips, and airport transfers.",
      prices: { airport: "Rs. 1500", "8hr": "Rs. 2000", "12hr": "Rs. 2500", outstation: "Rs. 12/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Swift-Dzire.jpg"
     
    },
    {
      id: 3,
        name: "Toyota Innova",
      tag: "Premium Fleet",
      description: "Trusted 7-seater SUV for local city rides, corporate meetings, airport pickups, and long-distance travel.",
      prices: { airport: "Rs. 1400", "8hr": "Rs. 2500", "12hr": "Rs. 3200", outstation: "Rs. 16/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Innova.jpg"
      
    },
    {
      id: 4,
       name: "Tempo Traveller 17 Seater",
      tag: "Premium Fleet",
      description: "Spacious minibus with 17 seats, best choice for large groups and long-distance trips.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3000", "12hr": "Rs. 4000", outstation: "Rs. 25/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tempo-Traveller.jpg"
    },
    {
      id: 5,
        name: "Toyota Crysta",
      tag: "Premium Fleet",
      description: "Looking for a luxury cab in Varanasi? Our Toyota Crysta offers unmatched comfort and reliability.",
      prices: { airport: "Rs. 1600", "8hr": "Rs. 3000", "12hr": "Rs. 4000", outstation: "Rs. 20/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Crysta.jpg"
    },
    {
      id: 6,
       name: "Honda City",
      tag: "Premium Fleet",
      description: "Luxury 4-seater sedan ideal for business travel, premium city rides, and smooth airport pickups.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3200", "12hr": "Rs. 4000", outstation: "Rs. 22/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Honda-City.jpg"
    },
    {
      id: 7,
       name: "Cruiser 10-13 Seater",
      tag: "Premium Fleet",
      description: "Perfect for medium-sized groups, offering comfort, reliability, and affordable fares for sightseeing, events, and city rides.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3500", "12hr": "Rs. 4500", outstation: "Rs. 20/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Cruiser-13-Seater.jpg"
    },
    {
      id: 8,
      name: "Urbania 16 Seater",
      tag: "Premium Fleet",
      description: "Modern luxury van with 16 seats, designed for ultimate comfort and premium group travel.",
      prices: { airport: "Rs. 3500", "8hr": "Rs. 4500", "12hr": "Rs. 7500", outstation: "Rs. 34/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/urbania-trav.png"
    
    }
  ];



const BookCab = () => {
  const handleBookNow = (carName) => {
    // You can implement booking logic here
    console.log(`Booking ${carName}`);
    // Or redirect to booking page
    // window.location.href = `/book?car=${carName}`;
  };

  return (
    <section className="fleet-section" id="book-cab">
      <div className="fleet-container">
        {/* Header */}
        <motion.div 
          className="fleet-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2>Premium Fleet Rental</h2>
          <p>Book Your <span>Taxi</span></p>
          <p className="fleet-sub">
            Transparent pricing for local, outstation, and airport travel.
            Select your preferred vehicle and get instant confirmation.
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div 
          className="fleet-stats"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div>
            <div>24/7</div>
            <span>Availability</span>
          </div>
          <div>
            <div>0%</div>
            <span>Hidden Fees</span>
          </div>
          <div>
            <div>5.0 <FaStar style={{ color: "#fbbf24", fontSize: "1.2rem" }} /></div>
            <span>User Rating</span>
          </div>
        </motion.div>

        {/* Cards Grid */}
        <div className="fleet-grid">
          {fleetData.map((car, index) => (
            <motion.div 
              className="fleet-card"
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <img 
                src={car.image} 
                alt={car.name}
                loading="lazy"
              />

              <div className="fleet-content">
                <h3>{car.name}</h3>
                <p className="fleet-desc">{car.desc}</p>

                <div className="price-grid">
                  <div>
                    <span>Airport</span>
                    {car.prices.airport}
                  </div>
                  <div>
                    <span>8Hr / 80KM</span>
                    {car.prices.hr8}
                  </div>
                  <div>
                    <span>12Hr / 120KM</span>
                    {car.prices.hr12}
                  </div>
                  <div>
                    <span>Outstation</span>
                    {car.prices.outstation}
                    <small>Min. 250KM / Day</small>
                  </div>
                </div>

                <div className="fleet-actions">
                  <motion.a
                    href="https://wa.me/+91 6307291567"
                    className="whatsapp-btn"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp /> WhatsApp
                  </motion.a>
                  <motion.button 
                    className="book-btn"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handleBookNow(car.name)}
                  >
                    Book Now
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Info */}
        <motion.div 
          className="fleet-info"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p><strong>No Hidden Costs:</strong> Toll, Parking & State Tax extra as per actual receipts.</p>
          <p><strong>Instant Booking:</strong> Vehicle & driver details within minutes.</p>
          <p><strong>Fuel Included:</strong> Local & airport fares include fuel and driver.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default BookCab;